import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

/**
 * List of feature flags that are hardcoded to be enabled for the widget.
 * These feature gates do not check Statsig for their values, and are always enabled.
 * @param key
 * @returns
 */
const ENABLED_FLAGS = new Set([
	// Enables local branding customisation (themeing + branding + new UI features)
	'csm-local-branding-customisation',
	// Disable unused markdown plugins (smart links)
	'csm-disable-unused-md-plugins',
	// Disable citations
	'csm-ai-remove-citations-in-widget',
	// Enables sending csm as product header in place of jira
	'csm_ai_enable_pass_csm_as_product_header',
]);

function booleanResolver(key: string) {
	return ENABLED_FLAGS.has(key);
}

export const configurePlatformFeatureFlags = (): void => {
	if (typeof window !== 'undefined') {
		if (typeof window.__PLATFORM_FEATURE_FLAGS__ === 'undefined') {
			window.__PLATFORM_FEATURE_FLAGS__ = {};
		}

		window.__PLATFORM_FEATURE_FLAGS__.booleanResolver = (key: string) => {
			try {
				return booleanResolver(key) || FeatureGates.checkGate(key);
			} catch {
				return false;
			}
		};
	}
};
